<template>
    <el-tooltip placement="bottom" :manual="true"
                ref="tooltip"
    >
        <span slot="content" v-html="formatAsHtml(value)"></span>
        <div class="text-dense"
             @mouseenter="showTooltip" @mouseleave="hideTooltip"
        >
            {{value}}
        </div>
    </el-tooltip>
</template>
<script>
	import {formatAsHtml} from "@/common/format";

	export default {
        data() {
            return {
                tooltipTimer: null
            };
        },
		computed: {
			value() {
				return this.params.valueFormatted || this.params.value;
            }
        },
		methods: {
			formatAsHtml,
		    showTooltip(event) {
                if (event.target.offsetHeight < event.target.scrollHeight) {
                    this.tooltipTimer = setTimeout(() => {
                        this.$refs.tooltip.showPopper = true
                    }, 500);
                }
            },
            hideTooltip() {
		        clearTimeout(this.tooltipTimer);
                this.$refs.tooltip.showPopper = false;
            },
		}
	};
</script>
